import { withProcedureWraper } from "../../../../..";
import { Error, Loading } from "../../../../../../../components";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateNoSalaryForm } from "../../../components/create-no-salary-leave-form";
import { useAFLRequest } from "../../../hooks";

const dataFallback = {};

export const NoSalaryEdit = withProcedureWraper(() => {
  const { data = dataFallback, isLoading: isRequestLoading, isFetching: isRequestFetching, isError } = useAFLRequest();

  if (isRequestLoading) return <Loading />;
  if (isError) return <Error description="Không tìm thấy dữ liệu" />;

  return (
    <ProcedureLayout title="Chỉnh sửa đơn xin nghỉ không lương" loading={isRequestFetching}>
      <CreateNoSalaryForm data={data} />
    </ProcedureLayout>
  );
});
